export class ValidatorUtils {
  static validateEcuadorRUC(ruc: string): boolean {
    if (!ruc || ruc.length !== 13) return false;

    const provinceCode = parseInt(ruc.substring(0, 2), 10);
    if (isNaN(provinceCode) || provinceCode < 1 || provinceCode > 24)
      return false;

    const thirdDigit = parseInt(ruc[2], 10);
    if (isNaN(thirdDigit) || thirdDigit > 9) return false;

    const establishmentCode = parseInt(ruc.substring(10, 13), 10);
    if (isNaN(establishmentCode) || establishmentCode < 1) return false;

    const baseNumber = ruc.substring(0, 10);

    if (thirdDigit >= 0 && thirdDigit <= 5) {
      return this.validatePersonalID(baseNumber);
    } else if (thirdDigit === 6) {
      return this.validatePublicEntityRUC(ruc);
    } else if (thirdDigit === 9) {
      return this.validatePrivateCompanyRUC(ruc);
    }

    return false;
  }

  static validatePersonalID(id: string): boolean {
    if (!id || id.length !== 10) return false;

    const checkDigit = parseInt(id[9], 10);
    if (isNaN(checkDigit)) return false;

    let sum = 0;
    for (let i = 0; i < 9; i++) {
      let digit = parseInt(id[i], 10);
      if (isNaN(digit)) return false;

      if (i % 2 === 0) {
        let product = digit * 2;
        if (product > 9) product -= 9;
        sum += product;
      } else {
        sum += digit;
      }
    }

    const calculatedDigit = (10 - (sum % 10)) % 10;
    return calculatedDigit === checkDigit;
  }

  private static validatePublicEntityRUC(ruc: string): boolean {
    const coefficients = [3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;

    for (let i = 0; i < coefficients.length; i++) {
      const digit = parseInt(ruc[i], 10);
      if (isNaN(digit)) return false;
      sum += digit * coefficients[i];
    }

    const checkDigit = parseInt(ruc[8], 10);
    let calculatedDigit = 11 - (sum % 11);
    if (calculatedDigit === 11 || calculatedDigit === 10) calculatedDigit = 0;

    return calculatedDigit === checkDigit;
  }

  private static validatePrivateCompanyRUC(ruc: string): boolean {
    const coefficients = [4, 3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;

    for (let i = 0; i < coefficients.length; i++) {
      const digit = parseInt(ruc[i], 10);
      if (isNaN(digit)) return false;
      sum += digit * coefficients[i];
    }

    const checkDigit = parseInt(ruc[9], 10);
    let calculatedDigit = 11 - (sum % 11);
    if (calculatedDigit === 11 || calculatedDigit === 10) calculatedDigit = 0;

    return calculatedDigit === checkDigit;
  }
}
